// extracted by mini-css-extract-plugin
export default {"modalParent":"modal_modalParent__kZhVz","modal":"modal_modal__KtSWS","modalChild":"modal_modalChild__JYRj6"};